import axios from 'axios';

export type TaskStatus = 'inProgress' | 'complete';
export type TaskAttachment = { fileId: string; fileName: string; mimeType: string };
export type TaskProject = { _id: string; name?: string | null; number?: string | null };
export type TaskUser = { _id: string; name: string };

export type Activity = {
  _id: string;
  title: string;
  description?: string;
  dueDate?: string;
  status: TaskStatus;
  project: { _id: string; name: string | null };
  assignTo: TaskUser[];
  attachments: TaskAttachment[];
};

class ServiceTasksController {
  async addTasks(data: FormData): Promise<void> {
    await axios.post('/api/tasks', data);
  }

  async updateTasks(data: FormData): Promise<void> {
    await axios.put('/api/tasks', data);
  }

  async getTask(id: string): Promise<Activity> {
    const response = await axios.get<Activity>(`/api/tasks/${id}`);
    return response.data;
  }

  async getProjectUsers(projectId: string): Promise<TaskUser[]> {
    const response = await axios.get<TaskUser[]>('/api/users/task', {
      params: { projectId },
    });
    return response.data;
  }

  async getProjectsForTasks(): Promise<TaskProject[]> {
    const response = await axios.get<{ data: TaskProject[] }>('/api/company/projects', {});
    return response.data.data;
  }
}

export const ServiceTasks = new ServiceTasksController();
